import type { CrmData } from "../types";
import { buildSeed } from "./seed";

const STORAGE_KEY = "orbit-crm:v1";

export function loadData(): CrmData {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return seedAndSave();
    const parsed = JSON.parse(raw) as CrmData;
    if (!parsed || !Array.isArray(parsed.companies) || !Array.isArray(parsed.opportunities)) {
      return seedAndSave();
    }
    // Backfill pentru date persistate inainte de modulul de billing.
    if (!Array.isArray(parsed.invoices)) {
      parsed.invoices = buildSeed().invoices;
      saveData(parsed);
    }
    return parsed;
  } catch {
    return seedAndSave();
  }
}

function seedAndSave(): CrmData {
  const data = buildSeed();
  saveData(data);
  return data;
}

export function saveData(data: CrmData): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function resetData(): CrmData {
  localStorage.removeItem(STORAGE_KEY);
  return seedAndSave();
}
